/* eslint-disable jsdoc/require-returns */
import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { withTranslation } from 'react-i18next';
import ReactJson from 'react-json-view';
// @material-ui/core components
import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles';
import withStyles from '@material-ui/core/styles/withStyles';
// global variables
import { flags } from 'config';
// our components
import dateFormat from 'helpers/dateHelper';
import CardBody from 'components/UI/Card/CardBody';
import GridItem from 'components/UI/Grid/GridItem';
import Card from 'components/UI/Card/Card';
import GridContainer from 'components/UI/Grid/GridContainer';
import Badge from 'components/UI/Badge/Badge';

/**
 * @description
 * Stateless component.
 *
 * @param {Object} props - Component props.
 */
const AdInfoSidebar = ({ data, classes, t }) => (
  <React.Fragment>
    <GridContainer>
      <GridItem xs={12} sm={6} md={12}>
        <Card style={{ marginTop: 16 }}>
          <CardBody>
            <h6>{t('ad.details.report')}</h6>
            {Object.keys(flags).map(
              flag =>
                data.ad[flag] && (
                  <div
                    className={`${classes.verticalAlignment}`}
                    style={{ justifyContent: 'space-between' }}
                    key={`flag-${flags[flag].name}`}
                  >
                    <div>
                      <span>
                        <b>{flags[flag].name}</b>
                      </span>
                      <p>
                        <Moment
                          date={data.ad[flag].lastFlaggedOn}
                          format="D MMM Y, HH:mm"
                        />
                      </p>
                    </div>

                    <Badge color="danger">{data.ad[flag].total}</Badge>
                  </div>
                ),
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
    {data.ad.reviewed && (
      <GridContainer>
        <GridItem xs={12} sm={6} md={12}>
          <Card style={{ marginTop: 16 }}>
            <CardBody>
              <h6>{t('ad.details.reviewed_info')}</h6>
              <div>
                <h6>{t('ad.details.reviewed_by')}</h6>
                <h5
                  data-cy="reviewedByFullname"
                  id={`reviewed-info-${data ? data.id : '0'}`}
                  className={classes.cardTitle}
                >
                  {data && data.ad.reviewedBy && data.ad.reviewedBy.fullname}
                </h5>
              </div>
              <div className={classes.userDetails}>
                <h6>{t('ad.details.reviewed_on')}</h6>
                <h5>{data && dateFormat(data.ad.reviewedOn, t)}</h5>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )}
    {data.ad.matchedRules && (
      <GridContainer>
        <GridItem xs={12} sm={6} md={12}>
          <Card style={{ marginTop: 16 }}>
            <CardBody>
              <h6>{t('review_queue.headers.rules')}</h6>
              <ReactJson src={data.ad.matchedRules} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )}
  </React.Fragment>
);

/**
 * AdInfo PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop user info received from parents
 * @param t - prop from HOC with string translations
 */

AdInfoSidebar.propTypes = {
  data: PropTypes.shape({}).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(userProfileStyles)(AdInfoSidebar));
